import { AccountingSlab, MCQTypes } from '@commenda/types/src/random';
import {
  CorporationType,
  Country,
  IncorporationRequestStatus,
} from '@prisma/client';

export enum TEntityOwnerType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE_ENTITY = 'CORPORATE_ENTITY',
}

export enum TCorporateRelationshipType {
  SUBSIDIARY = 'SUBSIDIARY',
  PARENT = 'PARENT',
}

export interface IUpdateIncorporationWizardUpdateWizardTypeProps {
  incorporationCountry?: Country;
  corporationType?: CorporationType;
}

export interface IIncorporationWizardRequestData {
  companyName?: string;
  companyNameSuffix?: string;
  hasCorporateShareholders?: boolean;
  needsHelpWithAccounting?: MCQTypes;
  accountingSlab?: AccountingSlab;
  hasEntitiesAroundTheWorld?: boolean;
  willBeSubsidiaryOfAnotherEntity?: boolean;
  hasRelatedPartyTransactionsBetweenEntities?: boolean;
  hasAccountantToHandleFilings?: boolean;
  user?: {
    name: string;
    email: string;
    businessDescription: string;
    country?: Country;
  };
  needsConsultation?: boolean;
}

export interface IIncorporationWizard {
  id: string;
  stepsPerformed: string[];
  status: IncorporationRequestStatus;
  currentStep: string;
  requestData: IIncorporationWizardRequestData;
  corporationType: CorporationType;
  incorporationCountry: Country;
  jurisdiction: string;
  createdAt: Date;
  lastUpdatedAt: Date;
  workRequestId: string;
  companyId: number;
  companyName: string;
  companyNameSuffix: string;
  workRequestURL?: string;
}

export type USIncorporationWizardRequestDataProps = {
  userHasCurrentAddressInUS?: boolean;
  entityOwnerType?: TEntityOwnerType;
  areShareholdersCitizensOfIndia?: boolean;
  isCorporateShareholderIndianEntity?: boolean;
  numberOfIndianDirectorsInIndia?: number;
  corporateRelationshipWithIndianEntity?: TCorporateRelationshipType;
  haveCharteredAccountantInIndia?: boolean;
  willBeAPartOfLargerCorporateStructure?: boolean;
  hasRelatedPartyTransactionsBetweenEntities?: boolean;
  numberOfEntitiesCurrentEntityWillBeRelatedTo?: number;
  hasAccountantToHandleFilings?: boolean;
  user?: { name: string; email: string; businessDescription: string };
  anyShareholderIndianTaxResident?: boolean;
};

export type INLLPIncorporationWizardRequestDataProps = {
  areMembersTaxResidentsOfCountryOtherThanIndia?: boolean;
  numberOfNonIndianTaxResidents?: number;
  hasAccountantToHandleFilings?: boolean;
  user?: { name: string; email: string; businessDescription: string };
};

export type INPrivateLimitedIncorporationWizardRequestDataProps = {
  entityOwnerType?: TEntityOwnerType;
  numberOfIndividualForeignShareholders?: number;
  numberOfCorporateForeignShareholders?: number;
  areAnyOfDirectorsIndianTaxResidents?: boolean;
  haveExistingIndianAddress?: boolean;
  willBeAPartOfLargerCorporateStructure?: boolean;
  hasRelatedPartyTransactionsBetweenEntities?: boolean;
  numberOfEntitiesCurrentEntityWillBeRelatedTo?: number;
  hasAccountantToHandleFilings?: boolean;
  user?: { name: string; email: string; businessDescription: string };
};

export class UKPvtLtdIncorporationWizardRequestDataProps {
  isUKResident?: boolean;

  isAnyDirectorUKResident?: boolean;

  hasAddressInUK?: boolean;

  hasEntitiesAroundTheWorld?: boolean;

  willBeSubsidiaryOfAnotherEntity?: boolean;

  hasRelatedPartyTransactionsBetweenEntities?: boolean;

  hasAccountantToHandleFilings?: boolean;
}

export class SGPteLtdIncorporationWizardRequestDataProps {
  isSGResident?: boolean;

  isAnyDirectorSGResident?: boolean;

  hasAddressInSG?: boolean;

  hasEntitiesAroundTheWorld?: boolean;

  willBeSubsidiaryOfAnotherEntity?: boolean;

  hasRelatedPartyTransactionsBetweenEntities?: boolean;

  willBeAPartOfLargerCorporateStructure?: boolean;

  numberOfEntitiesCurrentEntityWillBeRelatedTo?: number;

  hasAccountantToHandleFilings?: boolean;

  isSGOwnedByIndividualOrCorp?: string;

  anyIndianShareholder?: boolean;

  numberOfCorpShareholder?: number;

  numberOfShareholdersInIndia?: number;

  anyCorpShareholderIndianEntity?: boolean;

  isSubsidiaryOfIndianComp?: boolean;

  haveCAInIndia?: boolean;

  anySingaporeanDirectors?: boolean;

  numberOfDirectors?: number;

  numberOfIndividualShareholders?: number;

  planToHireIn6Months?: boolean;
}

export class UAEIncorporationWizardRequestDataProps {
  isUAEResident?: boolean;

  isAnyDirectorUAEResident?: boolean;

  hasAddressInUAE?: boolean;

  hasEntitiesAroundTheWorld?: boolean;

  willBeSubsidiaryOfAnotherEntity?: boolean;

  hasRelatedPartyTransactionsBetweenEntities?: boolean;

  hasAccountantToHandleFilings?: boolean;
}
